// src/utils/studentGroups.ts
import { StudentGroup } from '../services/ApiService.types';

// Serwer oddaje grupy w dowolnej kolejności — pokazujemy je po nazwie: po polsku, bez względu na wielkość
// liter, a liczby jak liczby („5a” przed „10b”)
export const sortGroupsByName = (groups: StudentGroup[]): StudentGroup[] => (
  [...groups].sort((a, b) => a.name.localeCompare(b.name, 'pl', { numeric: true, sensitivity: 'base' }))
);

// Nazwy grup ucznia — do etykiet przy jego nazwisku, w kolejności podanych grup
export const getStudentGroupNames = (groups: StudentGroup[], studentId: number): string[] => (
  groups.filter((group) => group.studentIds.includes(studentId)).map((group) => group.name)
);
